import React from "react";
import Card from "components/card";
import Table from "components/table";
import Button from "components/button/Button";
import DropzoneFile from "components/dropzone";
import CommonModal from "components/modals/Modal";
import useCSVGoodsForm from "./hooks/useCSVGoodsForm";
import { ModalBody, ModalCloseButton, ModalHeader } from "@chakra-ui/modal";
import { MdFileDownload } from "react-icons/md";
import { createPortal } from "react-dom";
import { useForm } from "react-hook-form";

const CSVGoodsForm: React.FC = () => {
  const maxFiles = 5;
  const {
    formState: { errors },
  } = useForm();
  const {
    files,
    parsedCSV,
    isLoading,
    importStatus,
    setImportStatus,
    setParsedCSV,
    dropFile,
    removeFile,
    arrangeFiles,
    changeFile,
    rowImages,
    isOpen,
    onClose,
    onSubmit,
    openModal,
    handleAddImageRow,
    productImages,
    dropProductImages,
    removeProductImages,
    arrangeProductImages,
    changeProductImages,
    handleDownloadTemplate,
    loadCategoryOptions,
    loadBrandOptions,
    rowCategories,
    rowBrands,
    handleOnCategoryChange,
    handleOnBrandChange,
  } = useCSVGoodsForm();

  const columnHeaders = [
    { sku_product: "SKU Produk" },
    { name: "Nama Produk" },
    { description: "Deskripsi" },
    { price: "Harga" },
    { max_purchase: "Maks. Pembelian" },
    { weight: "Berat" },
    { category_selector: "Kategori" },
    { brand_selector: "Merk" },
    { image_link: "Gambar Produk" },
  ];

  return (
    <Card extra={"w-full h-full sm:overflow-auto px-6 pb-3 mt-5"}>
      <header className="relative flex items-center justify-between pt-4">
        <div className="text-xl font-bold text-navy-700 dark:text-white">
          CSV Tambah Barang
        </div>
        <Button
          children="Download Template"
          size="fit"
          variant="primary"
          icon={<MdFileDownload />}
          onClick={handleDownloadTemplate}
        />
      </header>

      <form onSubmit={(e) => onSubmit(e)}>
        <div className="mt-8">
          <div className="flex flex-col">
            <label htmlFor="csv" className="label required">
              File CSV Barang
            </label>
            <DropzoneFile
              text="Template Barang CSV"
              accept={{
                "text/csv": [".csv"],
              }}
              maxSize={1024000}
              maxFiles={1}
              files={files}
              dropFile={(files: File[]) => {
                setImportStatus(false);
                setParsedCSV([]);
                dropFile(files);
              }}
              removeFile={(files: File[]) => removeFile(files)}
              arrangeFiles={(files: File[]) => arrangeFiles(files)}
              changeFile={(files: File[]) => {
                setImportStatus(false);
                setParsedCSV([]);
                changeFile(files);
              }}
            />
          </div>
          {parsedCSV.length > 0 && (
            <div>
              <h5 className="ml-3 mt-7 font-bold text-gray-800">
                Detail Barang
              </h5>
              {/* <ColumnsTable tableData={parsedCSV} /> */}
              <Table
                hasHeader={false}
                tableTitle="Daftar Biaya Tambahan"
                tableData={parsedCSV}
                columnHeaders={columnHeaders}
                handleUpdate={(data) => {}}
                handleDelete={(data) => {}}
                handleAddImageRow={(data) => openModal(data)}
                loadCategoryOptions={loadCategoryOptions}
                loadBrandOptions={loadBrandOptions}
                selectedCategories={rowCategories}
                selectedBrands={rowBrands}
                onInputCategoryChange={handleOnCategoryChange}
                onInputBrandChange={handleOnBrandChange}
                errors={errors}
              />
            </div>
          )}
        </div>
        {files.length > 0 && (
          <Button
            children={`${importStatus ? "Simpan" : "Preview Data"}`}
            size="fit"
            variant="primary"
            extra="mt-7 mb-5"
            disabled={isLoading || files.length === 0}
            isLoading={isLoading}
          />
        )}
      </form>
      {createPortal(
        <CommonModal
          size="2xl"
          children={
            <div>
              <ModalHeader>Foto Barang</ModalHeader>
              <ModalCloseButton />
              <ModalBody>
                <form
                  onSubmit={(e) => handleAddImageRow(e)}
                  encType="multipart/form-data"
                >
                  <div className="mt-8">
                    <div className="flex flex-col">
                      <label htmlFor="images" className="label required">
                        Foto Barang
                      </label>
                      <DropzoneFile
                        text="Foto Barang"
                        accept={{
                          "image/*": [".jpg", ".png", ".jpeg", ".webp"],
                        }}
                        maxSize={2048000}
                        maxFiles={maxFiles - rowImages.length}
                        files={productImages}
                        dropFile={(files: File[]) => dropProductImages(files)}
                        removeFile={(files: File[]) =>
                          removeProductImages(files)
                        }
                        arrangeFiles={(files: File[]) =>
                          arrangeProductImages(files)
                        }
                        changeFile={(files: File[]) =>
                          changeProductImages(files)
                        }
                      />
                    </div>
                  </div>
                  <Button
                    children="Simpan"
                    size="fit"
                    variant="primary"
                    extra="mt-7 mb-5"
                    disabled={isLoading || files.length === 0}
                    isLoading={isLoading}
                  />
                </form>
              </ModalBody>
            </div>
          }
          isOpen={isOpen}
          onClose={onClose}
        />,

        document.body
      )}
    </Card>
  );
};

export default CSVGoodsForm;
